// Mock data for Ocean Energy Industrial (frontend-only clone)
// NOTE: All content below is MOCKED for preview. Backend integration comes later.

export const brand = {
  name: "Ocean Energy Industrial",
  short: "Ocean Energy",
  tagline: "ON LAND. AT SEA.",
  heroHeadline: "The Power Behind Progress.",
  established: 1943,
};

export const navItems = [
  {
    label: "Company",
    path: "/about-owner",
    children: [
      { label: "About the Owner", path: "/about-owner" },
      { label: "Sustainability", path: "/sustainability" },
      { label: "Products", path: "/products" },
    ],
  },
  {
    label: "On Land.",
    path: "/on-land",
    children: [
      { label: "Power Generation", path: "/on-land" },
      { label: "Data Centers", path: "/on-land" },
      { label: "Hybrid Microgrids", path: "/on-land" },
    ],
  },
  {
    label: "At Sea.",
    path: "/at-sea",
    children: [
      { label: "Marine Propulsion", path: "/at-sea" },
      { label: "Marine Gensets", path: "/at-sea" },
    ],
  },
  { label: "Grid-Free Power", path: "/grid-free-power" },
  {
    label: "Service",
    path: "/products",
    children: [
      { label: "Spare Parts", path: "/products" },
      { label: "Field Service", path: "/products" },
    ],
  },
  { label: "Contact", path: "/contact" },
];

export const images = {
  heroEngine:
    "https://images.unsplash.com/photo-1624880403473-4244deee045a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  onLand:
    "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  atSea:
    "https://images.unsplash.com/photo-1585713181935-d5f622cc2415?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gridFree:
    "https://images.unsplash.com/photo-1523559094051-53bac879eb80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  sustainability:
    "https://images.unsplash.com/photo-1591200834528-4050ce99fe78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tanker:
    "https://images.unsplash.com/photo-1658684276903-d01b7974ca90?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cargoOpen:
    "https://images.pexels.com/photos/36563587/pexels-photo-36563587.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  contact:
    "https://images.unsplash.com/photo-1591200834528-4050ce99fe78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const aboutParagraphs = [
  "Ocean Energy Industrial builds medium-speed liquid and gas fuelled reciprocating engines for marine and land-based applications worldwide.",
  "On land and at sea, our engines can be found operating in some of the most demanding and hostile environments on earth.",
  "With decades of engineering heritage, we continue to develop our platforms for the next generation of fuels in readiness for the global energy transition.",
  "Of the thousands of engines we have delivered to date, a remarkable share remain in active service — a testament to the quality and reliability of an Ocean Energy engine.",
  "We not only build outstanding medium-speed engines, we also assemble and test complete generator sets, design modular power plants, and partner to deliver turn-key microgrid power solutions.",
];

export const didYouKnow = [
  "Ocean Energy engines are engineered to run on biogas and e-methane without any modification.",
  "We have built thousands of iconic medium-speed engines, with over half still in service today.",
  "Our lean-burn gas engine technology continues to operate reliably decades after installation.",
  "Ocean Energy Industrial is a privately held engineering group focused on the energy transition.",
];

export const segments = {
  onLand: {
    title: "ON LAND.",
    body: "Ocean Energy Industrial is focused on the future of the energy industry, offering a range of flexible solutions and services tailored to meet our customers' diverse needs. With our expertise, we provide reliable, cost-efficient and future-proof solutions across modular power generation, CHP, hybrid microgrids, utilities, data centers and mining.",
    cta: { label: "Learn More", path: "/on-land" },
  },
  atSea: {
    title: "AT SEA.",
    body: "Our medium-speed engines are favoured in marine applications for their efficiency, reliability and fuel flexibility — striking a balance between power output and fuel consumption while withstanding the rigours of continuous operation at sea. Robust construction and lower maintenance requirements make them a cost-effective choice for ship operators seeking longevity and performance.",
    cta: { label: "Learn More", path: "/at-sea" },
  },
};

export const gridFree = {
  eyebrow: "Grid-Free Power.",
  title: "Always On.",
  body: "Ocean Energy Industrial's Power Solutions Division unites world-class engineering to deliver modular, utility-grade power anywhere the grid can't reach or keep up. From remote mining operations to hyperscale data centers, we design, build and support complete power islands.",
  cta: { label: "Go to page", path: "/grid-free-power" },
};

export const owner = {
  name: "Kelvin Marshal",
  role: "Founder & Chairman, Ocean Energy Industrial",
  photo:
    "https://customer-assets-jt897jd0.emergentagent.net/job_ocean-industrial-hub/artifacts/xnes8xfp_8ff0299c-b68e-4439-a433-58c41082b6e1.png",
  intro:
    "Ocean Energy Industrial is led by Kelvin Marshal, whose vision has shaped the company into a trusted name in medium-speed engine and power-generation technology.",
  paragraphs: [
    "Kelvin Marshal founded Ocean Energy Industrial with a simple conviction: that dependable power should be available on land and at sea, in even the most demanding environments on earth. Over the years that conviction grew into a global engineering enterprise.",
    "With a background spanning marine engineering, power systems and industrial manufacturing, Kelvin has guided the company through decades of innovation — from the first diesel platforms to today's multi-fuel, future-ready engines.",
    "Today Kelvin remains closely involved in the company's strategic direction, championing the energy transition and investing in the people, research and facilities that keep Ocean Energy Industrial at the forefront of the industry.",
  ],
  quote:
    "We build engines to last a lifetime — and relationships to last even longer.",
  facts: [
    { label: "Leadership since", value: "Day one" },
    { label: "Industry focus", value: "Power & Marine" },
    { label: "Guiding value", value: "Reliability" },
  ],
};

export const sustainability = {
  title: "Sustainability at Ocean Energy Industrial",
  body: "We are dedicated to advancing sustainable energy solutions. Recognising the crucial role energy plays in our lives and its environmental impact, we are committed to championing clean alternatives for a greener future. We aim to lead our industry towards change through innovative studies on low-carbon Future Fuels and collaboration on hybrid renewable power generation — exploring Hydrogen, Methanol, Biofuels and Ammonia.",
  cta: { label: "Discover more", path: "/sustainability" },
  pillars: [
    { title: "Hydrogen", desc: "Zero-carbon combustion research for the fuels of tomorrow." },
    { title: "Methanol", desc: "Scalable low-carbon liquid fuel for marine and land use." },
    { title: "Biofuels", desc: "Drop-in renewable fuels compatible with today's engines." },
    { title: "Ammonia", desc: "Carbon-free energy carrier for the marine sector." },
  ],
};

export const events = [
  { date: "1 Dec", name: "Marintec China" },
  { date: "18 Nov", name: "Data Center World Paris" },
  { date: "3 Nov", name: "EURONAVAL" },
  { date: "3 Nov", name: "DCD Connect Virginia" },
  { date: "28 Oct", name: "MINEXPO Africa" },
];

export const products = [
  {
    model: "OE33:45",
    type: "Gas / Liquid Fuel",
    output: "5.1 – 10.6 MW",
    desc: "Flexible medium-speed platform for power generation and marine gensets.",
  },
  {
    model: "OE35:40V",
    type: "Gas Fuel",
    output: "8.0 – 12.0 MW",
    desc: "High-efficiency lean-burn gas engine for utility-grade power.",
  },
  {
    model: "OE36:45L",
    type: "Liquid Fuel",
    output: "6.0 – 9.5 MW",
    desc: "Robust in-line diesel engine for marine propulsion and land power.",
  },
  {
    model: "OE36:45V",
    type: "Liquid Fuel",
    output: "9.0 – 14.4 MW",
    desc: "V-configuration engine delivering maximum power density.",
  },
  {
    model: "OE25:33L",
    type: "Gas / Liquid Fuel",
    output: "1.9 – 3.6 MW",
    desc: "Compact medium-speed engine for distributed generation.",
  },
  {
    model: "OE26:33L",
    type: "Liquid Fuel",
    output: "2.0 – 3.9 MW",
    desc: "Reliable workhorse for continuous-duty applications.",
  },
];

export const enquiryTypes = [
  "Sales – On Land",
  "Sales – At Sea",
  "Request a Quote for Spare Parts",
  "Apply to Become a Supplier",
  "Careers & Internships",
  "General Enquiry",
];

export const footer = {
  address: "Ocean Energy Industrial\n72 S Emerson Avenue\nMontauk, NY 11954",
  columns: [
    {
      title: "Company",
      links: [
        { label: "About the Owner", path: "/about-owner" },
        { label: "Sustainability", path: "/sustainability" },
        { label: "Products", path: "/products" },
        { label: "Contact", path: "/contact" },
      ],
    },
    {
      title: "Solutions",
      links: [
        { label: "On Land", path: "/on-land" },
        { label: "At Sea", path: "/at-sea" },
        { label: "Grid-Free Power", path: "/grid-free-power" },
      ],
    },
  ],
};
